<template>
  <div class="page">
    <div class="header">
      <img class="left-logo" @click="toggleFullScreen" src="https://cdn.spbcn.org/gcscc/gcscc-rank-left.png" alt="">
      <img class="tit" src="https://cdn.spbcn.org/gcscc/gcscc-rank-title.png" alt="">
      <img class="right-logo1" @click="toggleFullScreen" src="https://cdn.spbcn.org/gcscc/gcscc-right-logo1.png" alt="">
      <img class="right-logo2" @click="toggleFullScreen" src="https://cdn.spbcn.org/gcscc/gcscc-right-logo2.png" alt="">
    </div>
    <div class="rank-flex">
      <div class="rank-item" v-for="(value, key) in rankData" :key="key">
        <div class="rank-title">{{ titleList[key].cn }}</div>
        <div class="rank-title-en">{{ titleList[key].en }}</div>
        <div class="rank-list">
          <div class="rank-list-title">
            <div class="w1">排名</div>
            <div class="w2">姓名</div>
            <div class="w1">分数</div>
            <div class="w1">用时</div>
          </div>
          <div class="rank-wrapper">
            <div class="scroll-list">
              <div class="rank-list-item" v-for="(item, i) in value" :key="i">
                <div class="w1">{{ item.ranking }}</div>
                <div class="w2">{{ item.name }}</div>
                <div class="w1">{{ item.score }}</div>
                <div class="w1">{{ item.timePattern }}</div>
              </div>
              <!-- <div class="rank-list-item" v-for="(item, i) in value" :key="'copy-' + i">
                <div class="w1">1</div>
                <div class="w2">王小明</div>
                <div class="w1">25</div>
                <div class="w1">12:09</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      code: '',
      timer: null,
      scrollDuration: 0, // 根据数据长度计算持续时间
      group0: [],
      isPaused: false,
      rankData: [],
      titleList: [
        { cn: '小初组', en: 'Beginner Group' },
        { cn: '小中组', en: 'Intermediate Group' },
        { cn: '小高组', en: 'Advanced Group' },
        { cn: '初中组', en: 'Middle School' }
      ]
    }
  },
  // computed: {
  //   scrollStyle () {
  //     return {
  //       animationDuration: `${this.scrollDuration}s`,
  //       animationPlayState: this.isPaused ? 'paused' : 'running'
  //     }
  //   }
  // },
  created () {
    this.getList()
    this.intervalFn()
  },
  beforeDestroyed () {
    clearInterval(this.timer)
    this.timer = null
  },
  methods: {
    intervalFn () {
      this.timer = setInterval(() => {
        this.getList()
      }, 10000)
    },
    getList () {
      this.$http.post('/gcsccMatchCode/winners', { code: this.$route.query.code }).then(res => {
        if (res.code === 200) {
          this.rankData = res.data
        }
      })
    },
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        this.enterFullScreen()
      } else {
        this.exitFullScreen()
      }
    },
    // 全屏
    enterFullScreen () {
      const element = document.documentElement
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) { /* Firefox */
        element.mozRequestFullScreen()
      } else if (element.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        element.webkitRequestFullscreen()
      } else if (element.msRequestFullscreen) { /* IE/Edge */
        element.msRequestFullscreen()
      }
    },
    // 退出全屏
    exitFullScreen () {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.mozCancelFullScreen) { /* Firefox */
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
        document.webkitExitFullscreen()
      } else if (document.msExitFullscreen) { /* IE/Edge */
        document.msExitFullscreen()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.page{
  width: 100vw;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: auto;
  background: linear-gradient(45deg, #2634b4, #080f46);
}
.header{
  height: 160px;
  position: relative;
  text-align: center;
  padding-top: 20px;
  .tit{
    height: 150px;
  }
  .left-logo{
    position: absolute;
    left: 40px;
    top: 40px;
    height: 54px;
  }
  .right-logo1{
    position: absolute;
    right: 170px;
    top: 30px;
    width: 120px;
  }
  .right-logo2{
    position: absolute;
    right: 30px;
    top: 30px;
    width: 120px;
  }
}
.rank-flex{
  display: flex;
  justify-content: space-around;
  padding: 10px 20px;
  height: calc(100vh - 200px);
  .rank-item{
    flex: 1;
    min-width: 0;
    max-width: 35%;
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    margin: 10px;
  }
  .rank-title{
    text-align: center;
    font-size: 28px;
    font-weight: bold;
    color: #000;
    line-height: 30px;
  }
  .rank-title-en{
    font-size: 14px;
    text-align: center;
    color: #000;
  }
  // .rank-wrapper{
  //   position: relative;
  //   overflow: hidden;
  //   .scroll-list {
  //     position: absolute;
  //     animation: scroll linear infinite;
  //     left: 0;
  //     right: 0;
  //   }
  //   @keyframes scroll {
  //     0% { transform: translateY(0); }
  //     100% { transform: translateY(-50%); }
  //   }
  // }
  .rank-wrapper{
    overflow: hidden;
    height: calc(100vh - 358px);
  }
  .scroll-list{
    height: calc(100vh - 358px);
    overflow-y: auto;
  }
  .rank-list-title{
    display: flex;
    align-items: center;
    justify-content: space-around;
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 0;
    padding-right: 10px;
    font-size: 18px;
    font-weight: bold;
    color: #000;
  }
  .rank-list-item{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: 0;
    padding-right: 10px;
    margin-bottom: 10px;
    background-color: #ebebeb;
    height: 40px;
    border-radius: 40px;
    font-size: 20px;
    font-weight: bold;
    color: #000;
  }
}
.w1{
  width: 20%;
  text-align: center;
}
.w2{
  width: 40%;
  text-align: left;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}
</style>
